import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Child Details", -1)
const _hoisted_3 = { class: "mt-2 text-gray-800" }
const _hoisted_4 = { class: "mt-6 border border-gray-400 rounded" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Parent/Carer", -1)
const _hoisted_7 = { class: "mt-2 text-gray-800" }
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "flex justify-between px-4 py-2" }
const _hoisted_13 = { class: "flex items-center space-x-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Make Primary Carer", -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mt-6" }
const _hoisted_17 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_18 = { class: "text-3xl font-medium capitalize" }
const _hoisted_19 = { class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded" }
const _hoisted_20 = { class: "w-full px-4 py-2" }
const _hoisted_21 = { class: "flex items-center space-x-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl font-medium" }, "Additional", -1)
const _hoisted_23 = { class: "text-sm text-gray-700" }
const _hoisted_24 = { class: "mt-6" }
const _hoisted_25 = { class: "text-3xl font-medium" }
const _hoisted_26 = { class: "mt-4" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex flex-wrap gap-4 py-6" }

import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from "pinia";

import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import RouterButton from "@/components/RouterButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";

import api from "@/api/api";
import { Student } from "@/types";
import { userHasRole } from "@/utils/roles";
import { useGlobalStore, useUserStore } from "@/store";
import ReadOnlyNote from "@/components/ReadOnlyNote.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditStudent',
  async setup(__props) {

let __temp: any, __restore: any

const router = useRouter();
const route = useRoute();
const globalStore = useGlobalStore();
const { user, userIsAdmin } = storeToRefs(useUserStore());
const isSaving = ref(false);

const club_id = Number(route.params.id);

const isDeleteChildModalOpen = ref(false);
const student = ref({} as Student);
const parents = ref([] as { id: string; first_name: string; last_name: string; email: string; is_primary: boolean }[]);

const isParent = computed(() => {
  return userHasRole(user.value.roles, ["parent", "brick-club-family"]);
});

function addParent() {
  parents.value.push({
    email: "",
    first_name: "",
    last_name: "",
    is_primary: false,
    id: "",
  });
}

function removeParent(index: number) {
  if (index === 0) return;
  parents.value.splice(index, 1);
}

function togglePrimaryParent(index: number) {
  parents.value.map(parent => (parent.is_primary = false));
  parents.value[index].is_primary = !parents.value[index].is_primary;
}

function getParents() {
  return student.value.parents.map(p => ({
    id: p.id,
    email: p.email,
    first_name: p.first_name,
    last_name: p.last_name,
    is_primary: p.id === student.value.primary_parent,
  }));
}

async function saveStudent() {
  /** Check first and last name are maximum 3 letters */
  if (student.value.first_name.length > 3) {
    globalStore.toast("ERROR", "First name must be maximum 3 letters");
    return;
  }

  if (student.value.middle_name.length > 3) {
    globalStore.toast("ERROR", "Middle name must be maximum 3 letters");
    return;
  }

  if (student.value.last_name.length > 3) {
    globalStore.toast("ERROR", "Last name must be maximum 3 letters");
    return;
  }

  /** Do parent email check first */
  const results = (
    await api.students.checkParentEmailsByFacilitator(
      String(club_id),
      parents.value.map(p => p.email)
    )
  ).data;

  if (results.find(r => !r.valid)) {
    globalStore.toast("ERROR", "One or more parent emails are already in use");
    return;
  }

  /** Save if user is Club Owner */
  if (!isParent.value) {
    try {
      const response = await api.clubs.updateClubStudent(club_id, student.value.id, {
        student: student.value,
        parents: parents.value,
      });

      globalStore.toast("SUCCESS", "Club Participant updated");
      return (window.location.href = `/dashboard/clubs/${club_id}/participants/${response.data.student.id}`);
    } catch (e) {
      console.log("ERROR", e);
      globalStore.toast("ERROR", "Error updating Participant");
      isSaving.value = false;
    }
  }

  /** Save if user is Parent */
  if (isParent.value) {
    try {
      const response = await api.students.updateStudentByParent(user.value.id, student.value.id, {
        student: student.value,
        parents: parents.value,
      });

      globalStore.toast("SUCCESS", "Child updated");
      return (window.location.href = `/dashboard/clubs/members/${response.data.student.id}`);
    } catch (e) {
      console.log("ERROR", e);
      globalStore.toast("ERROR", "Error updating Child");
      isSaving.value = false;
    }
  }
}

async function deleteChild() {
  try {
    await api.students.deleteStudentByParent(user.value.id, student.value.id);

    globalStore.toast("SUCCESS", "Child removed");
    return router.push({ name: "Brick_Club_Members" });
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error deleting Child");
  }
}

if (isParent.value) {
  student.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.students.getStudentByParent(user.value.id, route.params.student_id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.student;

  if (student.value.primary_parent !== user.value.id) {
    router.push(`/dashboard/children`);
  }
} else {
  student.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.clubs.getClubStudent(club_id, route.params.student_id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.student;
}

parents.value = getParents();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationModal, {
      buttonText: "Remove Child?",
      class: "danger",
      isOpen: isDeleteChildModalOpen.value,
      onDelete: deleteChild,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isDeleteChildModalOpen.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(" This will delete "),
          _createElementVNode("strong", null, _toDisplayString(student.value.first_name) + _toDisplayString(student.value.middle_name ? ` ${student.value.middle_name}` : "") + " " + _toDisplayString(student.value.last_name), 1),
          _createTextVNode(" from the platform. ")
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('edit club member')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("form", {
      class: "mt-8",
      onSubmit: _withModifiers(saveStudent, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("child-details-helptext")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ListRowItem, {
            title: _ctx.$t('first-name-initial')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((student.value.first_name) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
                maxlength: "3",
                required: ""
              }, null, 512), [
                [_vModelText, student.value.first_name]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('middle-name-initial')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((student.value.middle_name) = $event)),
                placeholder: "Name",
                class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
                maxlength: "3"
              }, null, 512), [
                [_vModelText, student.value.middle_name]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('family-name-initial')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((student.value.last_name) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 capitalize border border-gray-600 rounded",
                maxlength: "3",
                required: ""
              }, null, 512), [
                [_vModelText, student.value.last_name]
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("parent-carer-helptext")), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parents.value, (parent, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-6 border border-gray-400 rounded",
              key: index
            }, [
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('first-name')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": ($event: any) => ((parents.value[index].first_name) = $event),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_9), [
                    [_vModelText, parents.value[index].first_name]
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('last-name')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": ($event: any) => ((parents.value[index].last_name) = $event),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_10), [
                    [_vModelText, parents.value[index].last_name]
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('email')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": ($event: any) => ((parents.value[index].email) = $event),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_11), [
                    [_vModelText, parents.value[index].email]
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(ToggleCheckbox, {
                    value: parents.value[index].is_primary,
                    checked: parents.value[index].is_primary,
                    onToggle: ($event: any) => (togglePrimaryParent(index))
                  }, null, 8, ["value", "checked", "onToggle"]),
                  _hoisted_14
                ]),
                _createElementVNode("div", null, [
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-link",
                        type: "button",
                        onClick: ($event: any) => (removeParent(index))
                      }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(DefaultButton, {
            type: "primary",
            onClick: addParent
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("add-a-parent-carer")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(userIsAdmin))
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.$t("background-notes")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("background-notes-info")), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("parent-only-field-helptext")), 1)
                ]),
                _createVNode(ReadOnlyNote, {
                  content: student.value.additional_notes
                }, null, 8, ["content"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.$t("parent-carer-consent")), 1),
        _createElementVNode("div", _hoisted_26, [
          (student.value.survey_permission)
            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t("parent-attendance-session-notes-consent")), 1))
            : _createCommentVNode("", true),
          (!student.value.survey_permission)
            ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.$t("parent-consent-button")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        (!_unref(isParent))
          ? (_openBlock(), _createBlock(RouterButton, {
              key: 0,
              type: "primary",
              to: { name: 'Brick_Club', params: { id: _unref(club_id) } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_unref(isParent))
          ? (_openBlock(), _createBlock(RouterButton, {
              key: 1,
              type: "primary",
              to: { name: 'View_Child', params: { student_id: _unref(route).params.student_id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(DefaultButton, {
          id: "review",
          type: "primary",
          "is-form-submit": true,
          loading: isSaving.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("save-participant")), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        (_unref(isParent))
          ? (_openBlock(), _createBlock(DefaultButton, {
              key: 2,
              type: "danger",
              onAction: _cache[4] || (_cache[4] = ($event: any) => (isDeleteChildModalOpen.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("delete")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 40, _hoisted_1)
  ], 64))
}
}

})